export const foerderung = [
    {
      "id": 300,
      "type": "radio-step",
      "description":"type of real estate",
      "title": "Förderung für mehr Energieeffizienz",
      "options": [
        {  id:"0", value:"Beratung zu Förderprogrammen für Hauseigentum", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Beratung zu Förderprogrammen für Hauseigentum", "size":"m"}},
        {  id:"1", value:"Beratung zu Förderprogrammen für Sanierung", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Beratung zu Förderprogrammen für Sanierung", "size":"s"}},
        {  id:"2", value:"Beratung zu Förderprogrammen für Unternehmen", "next" : 998, "prev" : -1, "options": {"icon":"", "text":"Beratung Förderprogramme für Unternehmen", "size":"s"}},
        
      ]
    },
  ]